import { FeatureFlag } from '../FeatureFlag';

export const showLegacyLocatesWidgetBlocker = new FeatureFlag({
    key: 'show-legacy-locates-widget-blocker',
    defaultValue: true,
});
